import axios from 'axios';
import { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { Store } from '../../../store/player/types';

/**
 * Load a recording (not the current one) by list index, returning a Promise resolution or rejection.
 */
export const preloadRecordingByIndex = (
  store: Store,
  index: number,
): Promise<Recording> | undefined => {
  const { siteId, removeRecordingFromList, getRecordingIdByIndex } = store.getState();
  const recordingId = getRecordingIdByIndex(index);

  function onError() {
    removeRecordingFromList(recordingId);
    return Promise.reject(`Unable to load the recording`);
  }

  function preloadRecording(recordingId: number): Promise<Recording> {
    return axios
      .post(`/api/v1/sites/${siteId}/recordings/${recordingId}`, { action: 'exists' })
      .then((res) => Promise.resolve(res.data as Recording))
      .catch(() => onError());
  }

  return preloadRecording(recordingId);
};
